export default "__VITE_ASSET__BqVfN0yn__"